import { useEffect } from "react";

export default function Lightbox({
  photo,
  onClose,
  onPrev,
  onNext,
  hasPrev,
  hasNext,
  isCover,
  isCoverPending,
  onSetCover,
}) {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft" && hasPrev) onPrev();
      if (e.key === "ArrowRight" && hasNext) onNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose, onPrev, onNext, hasPrev, hasNext]);

  if (!photo) return null;

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lb-close" onClick={onClose} aria-label="關閉">×</button>

      <button
        className="lb-nav lb-prev"
        onClick={(e) => { e.stopPropagation(); if (hasPrev) onPrev(); }}
        disabled={!hasPrev}
        aria-label="上一張"
      >
        ‹
      </button>

      <div className="lb-stage" onClick={(e) => e.stopPropagation()}>
        <img src={photo.medium} alt={photo.originalName || photo.id} referrerPolicy="no-referrer" />
        <div className="lb-meta">
          <div className="lb-meta-left">
            {photo.uploader ? <span className="lb-uploader">— {photo.uploader}</span> : <span className="lb-uploader">— E118 同學</span>}
            {photo.exifDate && (
              <span className="lb-date">{new Date(photo.exifDate).toLocaleString("zh-TW")}</span>
            )}
            {photo.source === "drive" && <span className="lb-date">via Google Drive</span>}
          </div>
          <div className="lb-actions">
            {onSetCover && (
              <button
                className={`lb-cover-btn ${isCover ? "is-cover" : ""}`}
                onClick={(e) => { e.stopPropagation(); if (!isCover) onSetCover(e); }}
                disabled={isCoverPending || isCover}
              >
                {isCoverPending ? "設定中…" : isCover ? "★ 目前封面" : "☆ 設為封面"}
              </button>
            )}
            <a
              className="lb-download"
              href={photo.original}
              download={photo.originalName || photo.id}
              target={photo.source === "drive" ? "_blank" : undefined}
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              ⬇ 下載原圖
            </a>
          </div>
        </div>
      </div>

      <button
        className="lb-nav lb-next"
        onClick={(e) => { e.stopPropagation(); if (hasNext) onNext(); }}
        disabled={!hasNext}
        aria-label="下一張"
      >
        ›
      </button>
    </div>
  );
}
